export default {"src":"/_next/static/media/birth-certificate.fee9ffdf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};